export var Colors;
(function (Colors) {
    Colors["black"] = "#000000";
    Colors["white"] = "#ffffff";
    Colors["transparent"] = "transparent";
    Colors["inherit"] = "inherit";
    Colors["currentColor"] = "currentColor";
    Colors["grey000"] = "#FAFAFA";
    Colors["grey100"] = "#F2F2F2";
    Colors["grey200"] = "#E6E6E6";
    Colors["grey300"] = "#D9D9D9";
    Colors["grey400"] = "#CCCCCC";
    Colors["grey500"] = "#999999";
    Colors["grey700"] = "#666666";
    Colors["grey900"] = "#333333";
    Colors["red000"] = "#ffe1d5";
    Colors["red100"] = "#ffd2bf";
    Colors["red200"] = "#ffa38c";
    Colors["red500"] = "#ff4a00";
    Colors["red600"] = "#e52f00";
    Colors["red700"] = "#c63a00";
    Colors["blue100"] = "#f3f8ff";
    Colors["blue300"] = "#00bfff";
    Colors["blue500"] = "#136bf5";
    Colors["blue700"] = "#2655bd";
    Colors["orange100"] = "#feddc8";
    Colors["orange200"] = "#fec19b";
    Colors["orange500"] = "#fd7622";
    Colors["orange600"] = "#e46a1f";
    Colors["yellow100"] = "#fff0cf";
    Colors["yellow200"] = "#fff7e0";
    Colors["yellow400"] = "#ffcf61";
    Colors["yellow500"] = "#ffc43e";
    Colors["yellow600"] = "#e5b038";
    Colors["green000"] = "#daf5e6";
    Colors["green100"] = "#c4f3ea";
    Colors["green200"] = "#95ead9";
    Colors["green300"] = "#daf5e6";
    Colors["green400"] = "#62d493";
    Colors["green500"] = "#13d0ab";
    Colors["green600"] = "#11bb9a";
    Colors["aquamarine100"] = "#d1f2fb";
    Colors["aquamarine200"] = "#ace7f8";
    Colors["aquamarine500"] = "#46caef";
    Colors["aquamarine600"] = "#3fb6d7";
    Colors["purple100"] = "#d7d7fa";
    Colors["purple200"] = "#b7b8f7";
    Colors["purple500"] = "#6061ed";
    Colors["purple600"] = "#5657d5";
    Colors["pink100"] = "#fec6dc";
    Colors["pink200"] = "#fd99c0";
    Colors["pink500"] = "#fc1c74";
    Colors["pink600"] = "#e31968";
})(Colors || (Colors = {}));
//# sourceMappingURL=Colors.js.map
